import React, { Component } from 'react'

import { connect } from 'react-redux'
import * as api from '../api/api'
import * as actions from '../actions'

import { Button, ButtonIcon } from 'rmwc/Button';
import SerializeForm from 'form-serialize'
import { TextField, TextFieldIcon, TextFieldHelperText } from 'rmwc/TextField';
import { FormField } from 'rmwc/FormField';
import { Grid, GridCell } from 'rmwc/Grid';
import { Typography } from 'rmwc/Typography';
import { Card } from 'rmwc/Card';
import { Link } from 'react-router-dom'
import ReactPixel from 'react-facebook-pixel';
import GoogleTagManager from '../util/GoogleTagManager'

import StatusMessage from '../util/StatusMessage'


class UserReferral extends Component {
  constructor(props) {
    super(props)
    this.state = {
      status: '',
      message: '',
      errorMsg: '',
      referDisableStatus: false,
      referredStatus: false,
      referralCode: '',
      data: {
        first_name1:'',
        email1:'',
        phone1: '',
      },
      formErrors: {
       MandatoryAllError: '',
       emailPhoneMandatoryError: '',
       emailFormatError: '',
       phoneFormatError: ''
      }

    }

    this.validateForm = this.validateForm.bind(this);

  }

  emailValidate = () =>{
    if(this.state.data.email1 !== ''){
      let formErrors = Object.assign({}, this.state.formErrors)
      var pattern = /^[a-zA-Z0-9\-_]+(\.[a-zA-Z0-9\-_]+)*@[a-z0-9]+(\-[a-z0-9]+)*(\.[a-z0-9]+(\-[a-z0-9]+)*)*\.[a-z]{2,4}$/;
      if(pattern.test(this.state.data.email1)){
        return true
      }
      else{
        return false
      }
    }
  }


  phoneValidate = () =>{
    if(this.state.data.phone1 !== ''){
      let formErrors = Object.assign({}, this.state.formErrors)
      var pattern = /^\d+$/;
      if(pattern.test(this.state.data.phone1) && (this.state.data.phone1.length == 10)){
        return true
      }
      else{
        return false
      }
    }
  }

  componentDidMount() {
    

    let fetchReferral = 'user/fetch/referral_code'
    return api.getUserResponse(this.props.user.accessToken, fetchReferral)
    .then((result) => {
      if (result.status === 'success'){
        let referralCode = result.data
        this.setState({referralCode: referralCode})
      }
    })

  }

  onInputChange = evt => {
    const data = Object.assign({}, this.state.data);
    data[evt.target.name] = evt.target.value;
    this.setState({data});
  };

  validateForm(){

    let error = true
    let errorObj = Object.assign({}, this.state.formErrors)
    let data = Object.assign({}, this.state.data)
    let emailValid
    let phoneValid

    errorObj.MandatoryAllError=''
    errorObj.emailFormatError=''
    errorObj.phoneFormatError=''
    errorObj.emailPhoneMandatoryError=''

    if(data.first_name1 === '') {
        errorObj.MandatoryAllError ='Please provide a Name to refer.'
        error = false
    }
    
    if ((data.email1 === '') && (data.phone1 === '')) {
        errorObj.emailPhoneMandatoryError ='Please enter either an email or a mobile.'
        error = false
    }
    
    
    if(data.email1 !=='') {
        emailValid = this.emailValidate()
        console.log(emailValid)
        if (!emailValid){
          error = false
          errorObj.emailFormatError = 'Email Format is wrong. Please check if the email address you entered is correct.'
        }
      }

    console.log(data.phone1)
    if(data.phone1 !=='') {
        phoneValid = this.phoneValidate()
        if (!phoneValid){
          error = false
          errorObj.phoneFormatError = 'Phone Format is wrong. Correct format is 10 digit mobile number with No Country Code'
        }
      }
    

    this.setState({
      formErrors:errorObj,
      errorMsg:''
    })
    return error

  }

  
  handleSubmit = (evt) => {
    evt.preventDefault()
    let data = Object.assign({}, this.state.data)
    if(this.validateForm()){
      
      let apiInput = {
       'first_name': data.first_name1,
       'email': data.email1,
       'phone': data.phone1,
      }

      /* RETURNINING HERE TO AVOID API CALL DURING DEVELOPMENT. TO BE REMOVED ONCE API IS COMPLETE */


      return api.userReferral(this.props.user.accessToken,apiInput)
        .then((result) => {
          if(result.status === 'success'){
            this.setState({referDisableStatus:false, referredStatus: true})
          }
          else{
            this.setState({ errorMsg: result.message, referredStatus: false})
          }
          })
          .catch((err) => {
            this.setState({ errorMsg: err.stack, referredStatus: false})
          })  
    }
  };
  
  handleReferAgain = (e) => {
    let data = Object.assign({}, this.state.data)
    let formErrors = Object.assign({}, this.state.formErrors)
    data.first_name1 = ''
    data.email1 = ''
    data.phone1 = ''
    formErrors.MandatoryAllError = '',
    formErrors.emailUniqueError = '',
    formErrors.emailFormatError = ''
    this.setState({data: data, formErrors: formErrors, referredStatus: false})
  }

  render(){
    let handleReferAgain = this.handleReferAgain
    let referralForm
    let referralData = (
      <Grid>
        <GridCell span = "4">
        </GridCell>
        <GridCell span = "4">
          <Typography use="headline6" align="center">Your referral code is <b>{this.state.referralCode}</b></Typography>
        </GridCell>
        <GridCell span = "4">
        </GridCell>
      </Grid>
    )

    

    if (this.state.referredStatus === false) {
      referralForm = (
        <GridCell span="12">
          <Card style={{padding: '15px'}}>
            <Grid className="opportunity-list-item">
              <GridCell span ="12">
                <Typography use="subtitle" align="left"><b>Fill in the details of your colleague, invite them to join MyCENTA & get rewarded</b></Typography>
              </GridCell>
              <GridCell span="4">
              <TextField fullwidth className='text_input' label="Name of the colleague" autoComplete="off" name="first_name1" onChange={this.onInputChange} value={this.state.data.first_name1}/>
              </GridCell>
              <GridCell span="4">
                <TextField fullwidth  className='text_input' label="Email" autoComplete="off"  name="email1" onChange={this.onInputChange} value={this.state.data.email1}/>
              </GridCell>
              <GridCell span="4">
                <TextField fullwidth  className='text_input' label="Mobile" autoComplete="off"  name="phone1" onChange={this.onInputChange} value={this.state.data.phone1}/>
              </GridCell>
              <GridCell span="12" className="button-section">
                <Button raised disabled={this.state.referDisableStatus} onClick={((e) => this.handleSubmit(e))}theme="secondary-bg on-secondary" >Invite</Button>                
              </GridCell>
              <GridCell span="12">
               Note : Please provide 10 digit mobile number without Country Code (91)
              </GridCell>
              <GridCell span="12">
                <StatusMessage error_msg = {this.state.errorMsg}/>
                <StatusMessage error_msg = {this.state.formErrors.MandatoryAllError}/>
                <StatusMessage error_msg = {this.state.formErrors.emailFormatError}/>
                <StatusMessage error_msg = {this.state.formErrors.phoneFormatError}/>
                <StatusMessage error_msg = {this.state.formErrors.emailPhoneMandatoryError}/>
              </GridCell>
              
            </Grid>
          </Card>
        </GridCell>
      )
    }
    else {
      referralForm = (
        <GridCell span = "12">
          <Card style={{padding: '10px'}}>
            <Typography use="headline7" align="left">An invitation has been sent to your friend, <b>{this.state.data.first_name1}</b>, with your Referral code (<b>{this.state.referralCode}</b>).</Typography>
            <br />
            <GridCell span = "12">
              <Typography use="headline7" align="left">To invite another colleague, please</Typography>
              <Typography className = "typography_link" use="headline7" onClick={((e) => handleReferAgain(e))}> <a style={{cursor: 'pointer'}}><u>Click here</u></a>.</Typography>
            </GridCell>
          </Card>
        </GridCell>
      )
    }
     

    return (
      <Grid>
        <GridCell span="12">
            <Card style={{padding: '25px'}}>
                <Typography use="headline5">User referral - Invite a colleague to join MyCENTA</Typography>
                
            </Card>
            <br />
            {referralData}
            <br />
            {referralForm}
      </GridCell>

      


    </Grid>

      )
  }

}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps(dispatch) {
  return {
    userLogin: data => dispatch(actions.userLogin(data)),
    adminLogin: data => dispatch(actions.adminLogin(data)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserReferral); 


// WEBPACK FOOTER //
// ./src/views/UserReferral.jsx